import { useQueryClient } from '@tanstack/react-query';
import { Patient } from 'infrastructure/classes/patient/patient';

import { useRpmPatientDetailsKey } from '../rpm';
import { getPatientInfoKey } from './use-patient-info';

import type { IPatient, IRpmPatientDetail } from 'infrastructure/interfaces';

export const useUpdatePatientInfoCache = () => {
  const queryClient = useQueryClient();

  const updateCache = (patientGuid: string, data: Partial<IPatient>) => {
    const detailsKey = useRpmPatientDetailsKey(patientGuid);
    const patientDetails =
      queryClient.getQueryData<IRpmPatientDetail>(detailsKey);

    if (patientDetails) {
      const clonedDetails: any = structuredClone(patientDetails);
      for (const key in patientDetails.profile) {
        if (key in data) {
          clonedDetails.profile[key] = data[key as keyof typeof data];
        }
        if (data.loginInfo && key in data.loginInfo) {
          clonedDetails.profile[key] =
            data.loginInfo[key as keyof typeof data.loginInfo];
        }
      }

      queryClient.setQueryData(detailsKey, clonedDetails);
    }

    const infoKey = getPatientInfoKey(patientGuid);
    const patientInfo = queryClient.getQueryData<IPatient>(infoKey);
    if (patientInfo) {
      queryClient.setQueryData(
        infoKey,
        new Patient({ ...patientInfo, ...data }),
      );
    }
  };

  return { updateCache };
};
